import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { CarouselPage } from 'src/app/shared/models/carousel/carousel-page.model';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-migration-onboarding',
  templateUrl: './migration-onboarding.component.html',
  styleUrls: ['./migration-onboarding.component.scss'],
})
/**
 * Instantiates Onboarding template with information
 */
export class MigrationOnboardingComponent implements OnInit {
  readonly labels = {
    step1: 'migration-onboarding-step-1',
    step2: 'migration-onboarding-step-2',
    step3: 'migration-onboarding-step-3',
  };
  carouselPages: CarouselPage[] = [
    new CarouselPage('star', this.labels.step1),
    new CarouselPage('domain', this.labels.step2),
    new CarouselPage('groups', this.labels.step3),
  ];

  /**
   * @constructor
   */
  constructor(
    private readonly router: Router,
    private readonly translationService: TranslationService
  ) {}

  /**
   * on init
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels).then(() => {
      this.carouselPages = [
        new CarouselPage('star', this.labels.step1),
        new CarouselPage('domain', this.labels.step2),
        new CarouselPage('groups', this.labels.step3),
      ];
    });
  }

  /**
   * Routes to home page
   */
  goToHome() {
    this.router.navigate([RoutesKeys.HOME]);
  }
}
